{
	"title": "Transaktionshistorik för {{productName}}",
	"item": {
		"time": "Tid",
		"description": "Beskrivning",
		"transactionId": "Transaktions-ID",
		"showIds": "Visa ID:n",
		"depositTitle": "Granskning av DNV som möjliggör en insättning i koldioxidbanken",
		"depositDescription": "När tredjepartsgranskaren ”DNV” har granskat den lagrade volymen infångad koldioxid i ett digitalt Monitor-Report-Verify-system görs en ny insättning i koldioxidbanken.",
		"withdrawalTitle": "Faktura till leverantör som utlöser ett uttag från koldioxidbanken",
		"withdrawalDescription": "När evoZero-materialet faktureras till leverantören har ett uttag från koldioxidbanken genomförts.",
		"transferTitle": "Överföring av koldioxidreduktioner till deklarationsinnehavaren",
		"transferDescription": "Leverantören initierade överföringen av koldioxidreduktionerna till deklarationsinnehavaren baserat på den evoZero-materialvolym som ingick i den levererade produkten."
	},
	"proofIdsModal": {
		"titleTransactions": "Visa transaktioner",
		"titleMeasurements": "Visa mätningar",
		"paragraph1": "Ett transaktionssteg på {{productName}} innebär att transaktioner aggregeras i den distribuerade liggaren. Nedan hittar du en lista med länkar till tredjepartstjänster där du kan se dessa transaktioner.",
		"paragraph2": "Observera att dessa länkar tar dig till externa webbplatser som erbjuder funktioner för att visa transaktioner.",
		"open": "Öppna",
		"close": "Stäng"
	},
	"errors": {
		"fetch": "Det gick inte att hämta aktivitetshistoriken"
	}
}
